module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_Home #gallery #fullscreenView":{"widgets.tipme.widget":[{"value":"Content_Tipme","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Layout_Home #gallery #fullscreenView","_fox_":1}],"widgets.tipme.embed.container":[{"value":".gallery-sidebar-tipme-form","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Layout_Home #gallery #fullscreenView","_fox_":1}],"widgets.tipme.template":[{"value":"content_gallery_fullscreen_view","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Layout_Home #gallery #fullscreenView","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/fullscreenGalleryTipme.js
// module id = 691
// module chunks = 4